import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";

export default class PageImageColumn extends Component {
	
	constructor(){
		super()
		this.state = {
			open: 		false,
			maxHeight: 0,
		}
		this.handleResize = this.handleResize.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}
    
	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
	
	handleToggle(_el) { 
    	this.setState({ open: !this.state.open });
    	console.log('open: ' + this.state.open);
    	setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
  	};
  	
  	handleResize() {
	  	if (this.accordionBody && this.accordionBodyInner && this.state.open === true) {
		  	console.log('oepn accordion');
	  		this.setState({maxHeight : this.accordionBodyInner.clientHeight});
  		} else {
	  		this.setState({maxHeight : 0});
  		}
  	}
  	
	render() {
		
		const item 	= this.props.item; 
		
		let butText = 'Read More +';
		if (this.state.isOpen === true) {
			butText = 'Read Less -';
		}
			
		return (
			
			<>
				
				<div className="c-columns__column__image">
					<FadeIn>
						{onload => (
							<img
								alt={''} 
								src={item.src} 
								srcSet={item.srcset} 
								onLoad={onload}
							/>
						)}
					</FadeIn>
				</div>
				
				{item.heading &&
					<div className={'c-columns__column__accordion c-columns__column__accordion--image ' + (this.state.open ? 'state-open' : "")}>
						
						<h4 className="c-columns__column__accordion__header" onClick={this.handleToggle} dangerouslySetInnerHTML={ {__html: item.heading + '<span>' + butText + '</span>'}}></h4>
								
						<div className="c-columns__column__accordion__body">
						
							<div className="c-columns__column__accordion__body__inner" ref={e => (this.accordionBody = e)} style={{maxHeight:this.state.maxHeight+'px'}}>
															
								<div className="scope-text" ref={e => (this.accordionBodyInner = e)} dangerouslySetInnerHTML={ {__html: item.text + item.read_more}}></div>
																	
							</div>
							
						</div>
				
					</div>
				}
			
			</>
		)
		
	}
							
}